import type { AlertDetailDto, AlertDto, AlertRuleDto } from "@/lib/api/types";

import { MOCK_TENANT_ID } from "../constants";
import { MOCK_DEVICES } from "./devices";

const now = () => new Date();

export const MOCK_ALERT_RULES: AlertRuleDto[] = [
  {
    id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaa1",
    tenant_id: MOCK_TENANT_ID,
    name: "High temperature",
    conditions: { metric: "temperature", op: ">", value: 65 },
    is_active: true,
    created_at: new Date(now().getTime() - 86400000 * 14).toISOString(),
    data_source: {
      device_id: MOCK_DEVICES[0]?.id ?? "33333333-3333-3333-3333-333333333301",
      channel: "temperature",
    },
    cooldown_minutes: 5,
  },
  {
    id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaa2",
    tenant_id: MOCK_TENANT_ID,
    name: "Link down",
    conditions: { metric: "rssi_dbm", op: "<", value: -95 },
    is_active: true,
    created_at: new Date(now().getTime() - 86400000 * 7).toISOString(),
  },
];

export const MOCK_ALERTS: AlertDto[] = [
  {
    id: "bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbb1",
    device_id: MOCK_DEVICES[0]?.id ?? null,
    tenant_id: MOCK_TENANT_ID,
    rule_id: MOCK_ALERT_RULES[0]?.id ?? null,
    message: "temperature exceeded 65 °C for 5 minutes",
    severity: "high",
    created_at: new Date(now().getTime() - 3_600_000).toISOString(),
    status: "active",
    trigger_value: 67.2,
  },
  {
    id: "bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbb2",
    device_id: MOCK_DEVICES[1]?.id ?? null,
    tenant_id: MOCK_TENANT_ID,
    rule_id: MOCK_ALERT_RULES[1]?.id ?? null,
    message: "weak signal — possible antenna fault",
    severity: "medium",
    created_at: new Date(now().getTime() - 21_600_000).toISOString(),
    status: "resolved",
    resolved_at: new Date(now().getTime() - 20_000_000).toISOString(),
    trigger_value: -97,
  },
  {
    id: "bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbb3",
    device_id: MOCK_DEVICES[2]?.id ?? null,
    tenant_id: MOCK_TENANT_ID,
    rule_id: null,
    message: "maintenance window started (manual)",
    severity: "low",
    created_at: new Date(now().getTime() - 86_400_000).toISOString(),
    status: "active",
  },
];

export function mockAlertDetail(id: string): AlertDetailDto | null {
  const base = MOCK_ALERTS.find((a) => a.id === id);
  if (!base) {
    return null;
  }
  const rule = base.rule_id ? (MOCK_ALERT_RULES.find((r) => r.id === base.rule_id) ?? null) : null;
  return { ...base, rule };
}
